/* Mutual Optical — 商品卡配色圆点：点击切换卡片主图
 *
 * 事件委托挂在 document 上，因此对集合页筛选/分页后重新渲染的卡片、
 * Section Rendering 返回的新卡片、以及收藏页动态插入的卡片都自动生效，无需重新初始化。
 */
(function () {
  'use strict';

  function cardOf(el) {
    return el.closest('.card-wrapper, .product-card-wrapper, .card') || null;
  }

  function mainImg(card) {
    // Dawn 卡片主图；第二张是 hover 图，切换配色后不应再盖住主图
    return card.querySelector('.card__media .media img:first-of-type') ||
           card.querySelector('.card__media img');
  }

  function apply(btn) {
    var wrap = btn.closest('[data-mo-swatches]');
    var card = cardOf(btn);
    if (!wrap || !card) return;

    var img = mainImg(card);
    var src = btn.getAttribute('data-img');
    if (img && src) {
      // 清掉 srcset，否则浏览器仍会按 srcset 选图而忽略新的 src
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
    }

    // 悬停第二张图会盖住刚切换的配色图，选色后隐藏它
    // Dawn 卡片默认「悬停切到第二张图」：hover 时第一张 opacity→0、第二张→1。
    // 选定配色后必须关掉它，否则鼠标仍停在卡片上时刚换的图会被置为透明（表现为整块空白）。
    var media = card.querySelector('.card__media .media');
    if (media) media.classList.remove('media--hover-effect');
    var imgs = card.querySelectorAll('.card__media .media img');
    if (imgs.length > 1) imgs[1].style.display = 'none';
    if (imgs.length) imgs[0].style.opacity = '1';

    // 让卡片上的链接都指向该配色的变体
    var url = btn.getAttribute('data-url');
    if (url) {
      card.querySelectorAll('a.full-unstyled-link, a.mo-card-select').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }

    wrap.querySelectorAll('.mo-card-swatch').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === btn));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mo-card-swatch');
    if (!btn) return;
    // 卡片整体是一个链接，必须拦住冒泡，否则点色块会直接跳走
    e.preventDefault();
    e.stopPropagation();
    apply(btn);
  });

  // 键盘：在一组色块内用左右方向键移动并切换
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var btn = e.target.closest && e.target.closest('.mo-card-swatch');
    if (!btn) return;
    var group = [].slice.call(btn.closest('[data-mo-swatches]').querySelectorAll('.mo-card-swatch'));
    var i = group.indexOf(btn);
    var nextBtn = group[(i + (e.key === 'ArrowRight' ? 1 : -1) + group.length) % group.length];
    if (nextBtn) { e.preventDefault(); nextBtn.focus(); apply(nextBtn); }
  });
})();
